export default __webpack_public_path__ + "static/satisfaction-guarantee-b3a7585d8934032486293cfca40c7ed3.svg";